import * as IOGateway from './main.js';

export {IOGateway};

export default IOGateway.Factory;
